import moment from "moment";

export function nowToString() {
    return moment().format("DD.MM.YYYY");
}
